module.exports = "<span input-guidance>{{message | translate}}</span>\n<itpx-uploader\n    [component]=\"component\"\n    [delegateSave]=\"true\" \n    [hiddeButtons]=\"true\" \n    [autoSave]=\"true\"\n    [imgSrc]=\"imgSrc\"\n    \n    [type]=\"type\"\n    [name]=\"name\"\n    [bucket]=\"bucket\"\n    [dimensions]=\"dimensions\"\n    (saveFinished)=\"uploadComplete($event)\">\n</itpx-uploader>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/dynamic-onboarding/logo/logo.component.html
// module id = ./src/app/core/components/dynamic-onboarding/logo/logo.component.html
// module chunks = main